import { InMemoryCache, makeVar, ReactiveVar } from '@apollo/client'
import { Customer } from '@dxp-module/singpass/dist/types/common/graphql/__generated__/graphql.autogenerated'
import { relayStylePagination } from '@apollo/client/utilities/policies/pagination'
import { clientInfoReset } from '../constants/clientInfoReset'

export const loadingInsuranceFormVar: ReactiveVar<boolean> =
  makeVar<boolean>(true)
export const clientInfo: ReactiveVar<Customer> =
  makeVar<Customer>(clientInfoReset)

const cache = new InMemoryCache({
  typePolicies: {
    MyAccountQuery: {
      fields: {
        dealsPage: relayStylePagination(false),
      },
    },
    DealFeature: {
      keyFields: false,
    },
  },
})

export default cache
